export const meta = {
  name: 'Calculator',
  alias: 'calculator'
} as const;
